import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Castle, Mail, Lock, LogIn, Loader2, AlertCircle, HelpCircle } from 'lucide-react';
import { useAuthStore } from '../lib/store';
import styles from './Login.module.css';

export default function Login() {
	const [email, setEmail] = useState('');
	const [password, setPassword] = useState('');
	const [error, setError] = useState('');
	const [isLoading, setIsLoading] = useState(false);

	const { login } = useAuthStore();
	const navigate = useNavigate();

	const handleSubmit = async (e: React.FormEvent) => {
		e.preventDefault();
		setError('');
		setIsLoading(true);

		const success = await login(email, password);

		if (success) {
			navigate('/');
		} else {
			setError('Invalid email or password');
		}

		setIsLoading(false);
	};

	return (
		<div className={styles.container}>
			<div className={styles.card}>
				<div className={styles.header}>
					<div className={styles.logo}>
						<Castle size={32} className={styles.logoIcon} />
						<span className={styles.logoText}>Ringfort</span>
					</div>
					<h1 className={styles.title}>Operator Portal</h1>
					<p className={styles.subtitle}>Sign in to access your operator dashboard</p>
				</div>

				<form onSubmit={handleSubmit} className={styles.form}>
					{error && (
						<div className={styles.error}>
							<AlertCircle size={16} />
							<span>{error}</span>
						</div>
					)}

					<div className={styles.field}>
						<label htmlFor="email" className={styles.label}>
							<Mail size={14} />
							<span>Email</span>
						</label>
						<input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="operator@example.com" required className={styles.input} />
					</div>

					<div className={styles.field}>
						<label htmlFor="password" className={styles.label}>
							<Lock size={14} />
							<span>Password</span>
						</label>
						<input id="password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Enter your password" required className={styles.input} />
					</div>

					<button type="submit" disabled={isLoading} className={styles.submitBtn}>
						{isLoading ? (
							<>
								<Loader2 size={18} className={styles.spinner} />
								<span>Signing in...</span>
							</>
						) : (
							<>
								<LogIn size={18} />
								<span>Sign In</span>
							</>
						)}
					</button>
				</form>

				<div className={styles.footer}>
					<HelpCircle size={14} />
					<p>Need help? Contact your account manager</p>
				</div>
			</div>
		</div>
	);
}
